import { Star } from 'lucide-react';
import { Tooltip } from '@/shared/ui';
import { cn } from '@/shared/lib/cn';
import styles from './FavoriteStar.module.css';

interface FavoriteStarProps {
  active: boolean;
  onToggle: () => void;
  label?: string;
  size?: number;
}

export const FavoriteStar: React.FC<FavoriteStarProps> = ({ active, onToggle, label, size = 18 }) => (
  <Tooltip content={active ? 'Убрать из избранного' : 'В избранное'}>
    <button
      type="button"
      className={cn(styles.button, active && styles.active)}
      aria-pressed={active}
      aria-label={label ?? (active ? 'Убрать из избранного' : 'В избранное')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
    >
      <Star size={size} />
    </button>
  </Tooltip>
);
